/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PaymentMethods,
  PaymentMethodState
} from '@/store/interfaces/paymentMethod';
import { RootState } from '@/store/interfaces/rootState';
import paymentMethodType from '@/store/types/paymentMethod';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): PaymentMethodState => {
  return {
    paymentMethodsList: [],
  };
};

const state: PaymentMethodState = initialState();

const getters: GetterTree<PaymentMethodState, RootState> = {
  [paymentMethodType.getters.GET_PAYMENT_METHODS_LIST]: state => {
    return state.paymentMethodsList;
  },
};

const mutations: MutationTree<PaymentMethodState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [paymentMethodType.mutations.SET_PAYMENT_METHODS_LIST]: (
    state,
    states: Array<PaymentMethods>
  ) => {
    const paymentMethods: Array<PaymentMethods> = states;

    state.paymentMethodsList = paymentMethods;
  },
};

const actions: ActionTree<PaymentMethodState, RootState> = {
  [paymentMethodType.actions.PAYMENT_METHODS_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/payment-methods')
        .then((res: AxiosResponse) => {
          commit(
            paymentMethodType.mutations.SET_PAYMENT_METHODS_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
